import React from 'react';
import MarkdownWithCitations from './MarkdownWithCitations';

function NotificationDraftView({ summary, cta, onCtaClick, isLoading, brand }) {
    return (
        <div className="py-4">
            {brand && (
                <div className="flex items-center gap-2 mb-3">
                    {brand.icon && (
                        <img src={brand.icon} alt="" className="w-5 h-5 rounded-full" />
                    )}
                    <span className="text-[15px] font-semibold text-gray-700 dark:text-gray-300">
                        {brand.name}
                    </span>
                </div>
            )}

            {summary && (
                <div className="mb-6">
                    <MarkdownWithCitations content={summary} />
                </div>
            )}

            {cta && (
                <div className="space-y-3">
                    {cta.intro && (
                        <p className="text-sm font-medium text-gray-600 dark:text-gray-400">
                            {cta.intro}
                        </p>
                    )}
                    <div className="space-y-2">
                        {(cta.items || []).map((item, i) => (
                            <button
                                key={i}
                                onClick={() => onCtaClick(item)}
                                disabled={isLoading}
                                className="w-full text-left px-4 py-3 rounded-xl border border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                <div className="font-medium text-sm text-gray-900 dark:text-gray-100">
                                    {item.label}
                                </div>
                                {item.description && (
                                    <div className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                                        {item.description}
                                    </div>
                                )}
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}

export default NotificationDraftView;
